<template>
  <div class="pageStyle">
    <div class="header">
      <div class="item"><span></span></div>
      <div class="item">最新产品动态汇总</div>
    </div>
    <div class="content">
      <div class="item" v-for="(item, index) in newsData" :key="index">
        <div>
          <span>{{ parseTime(item.createDateTime) }}</span>
          <span v-show="item.url" @click="toUrl(item.url)"
            >查看详情<van-icon name="arrow"
          /></span>
        </div>
        <div>
          <span v-if="item.productId"
            >【{{
              productList[0]
                ? productList.find((productListItem) => {
                    return item.productId == productListItem.id;
                  }).productName
                : item.productId
            }}】</span
          ><span>{{ item.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
Vue.use(Toast);
Vue.use(Icon);
import { parseTime } from "@/utils/index.js";
import { getProductList, getAllXcProductNews } from "@/api/product.js";
import { xcProductDict } from "@/api/product.js";
export default {
  data() {
    return {
      newsData: [],
      productList: [],
    };
  },

  mounted() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    xcProductDict().then((res) => {
      this.productList = res;
      getAllXcProductNews().then((newsRes) => {
        let o = newsRes.filter((item) => {
          return item.productId;
        });
        this.newsData = o.sort((a, b) => {
          return b.createDateTime - a.createDateTime;
        });
        Toast.clear();
      });
    });
  },

  methods: {
    parseTime,
    toUrl(url) {
      window.location.href = url;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productNews/index.vue